import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';
import { ZENJOB_CONTACT_EMAIL } from '../constants';
import { ContactContentBlockView } from './ContactContentBlockView';
import { ContactContentInfoCard } from './ContactContentInfoCard';
import { ContactContentCard } from './styledComponents';

export const DeleteProfileContent = () => {
  return (
    <ContactContentCard>
      <ContactContentInfoCard
        textArr={[
          getTrans('deleteProfilePage.infoCard.body1'),
          getTrans('deleteProfilePage.infoCard.body2')
        ]}
      />
      <ContactContentBlockView
        title={getTrans('contactZenjobPage.emailAddress.title')}
        textToCopy={ZENJOB_CONTACT_EMAIL}
      >
        <Text>{ZENJOB_CONTACT_EMAIL}</Text>
      </ContactContentBlockView>
      <ContactContentBlockView
        title={getTrans('contactZenjobPage.subject.title')}
        textToCopy={getTrans('deleteProfilePage.subject.body')}
      >
        <Text>{getTrans('deleteProfilePage.subject.body')}</Text>
      </ContactContentBlockView>
      <ContactContentBlockView
        title={getTrans('deleteProfilePage.textTemplate.title')}
        textToCopy={`${getTrans(
          'deleteProfilePage.textTemplate.body1'
        )}\n\n${getTrans('deleteProfilePage.textTemplate.body2')}\n\n${getTrans(
          'deleteProfilePage.textTemplate.body3'
        )}\n\n${getTrans('deleteProfilePage.textTemplate.body4')}`}
      >
        <Text>{getTrans('deleteProfilePage.textTemplate.body1')}</Text>
        <br />
        <Text>{getTrans('deleteProfilePage.textTemplate.body2')}</Text>
        <br />
        <Text>{getTrans('deleteProfilePage.textTemplate.body3')}</Text>
        <br />
        <Text>{getTrans('deleteProfilePage.textTemplate.body4')}</Text>
      </ContactContentBlockView>
    </ContactContentCard>
  );
};
